import { prepareAsterisksFromNote } from './table-utils';
import { Note } from '../models/types';
import { PriceListNote } from '../models/priceslist-note.model';

export const extractNotes = (priceListNotes: PriceListNote[], noteCodesInProducts: string[] = []): [Note[], Record<string, string>] => {
  let index = 0;
  const [notes, notationMarks] = priceListNotes.reduce<[Note[], Record<string, string>]>(
    ([notes, notationMarks], { code, text }) => {
      const general = !noteCodesInProducts?.length || !noteCodesInProducts.includes(code);
      index = general ? index : index + 1;
      const copyOfNotationMarks = { ...notationMarks };
      copyOfNotationMarks[`${code}`] = prepareAsterisksFromNote(general ? 0 : index);
      return [[...notes, { index, code, text, isGeneral: general }], copyOfNotationMarks];
    },
    [[], {}],
  );
  const sortedNotes = notes.sort((a, b) => (a.isGeneral === b.isGeneral ? 0 : a.isGeneral ? -1 : 1));
  return [sortedNotes, notationMarks];
};
